var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgRecords = function SvgRecords(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#records_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#2c2b27",
    d: "M5.625.5h8.74l3.124 3.125h5.636a6.36 6.36 0 0 1 4.383 1.75l.228.229 9.792 9.79.007.007A6.37 6.37 0 0 1 39.5 20v14.375a5.125 5.125 0 0 1-5.125 5.125h-17.5a6.36 6.36 0 0 1-4.385-1.752l-.221-.22-.008-.008-9.784-9.786-.008-.007-.22-.221A6.36 6.36 0 0 1 .5 23.125v-17.5A5.125 5.125 0 0 1 5.625.5Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebe5d2",
    d: "M25 23.125C25 24.16 24.16 25 23.125 25H6.875A1.875 1.875 0 0 1 5 23.125V6.875C5 5.839 5.84 5 6.875 5H12.5l3.125 3.125h7.5C24.16 8.125 25 8.965 25 10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M16 19h5v2h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebe5d2",
    d: "M31.863 30.66a1.56 1.56 0 0 1 1.783.968l-.642.246a.875.875 0 1 0 .029.54l.664.178a1.562 1.562 0 1 1-1.834-1.933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebe5d2",
    fillRule: "evenodd",
    d: "M32.188 29.375a2.813 2.813 0 1 1 0 5.625 2.813 2.813 0 0 1 0-5.625m0 .619a2.193 2.193 0 1 0 0 4.387 2.193 2.193 0 0 0 0-4.387",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "records_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#fff",
    rx: 1
  }))))));
};
export default SvgRecords;